import { Component, ojs, app, v, payload, state } from "modular-openscriptjs";
import {
    either,
    formatThousand,
    pageInfo,
    fireEvent,
    eParse,
    tab,
    inform,
    empty,
    searchPlaceholder,
    clearSearchSuggestion,
} from "../../../helpers";
import { PAGES, gc, uc, pc, api, dc, STRINGS } from "../../../declarations";
import { dom } from "../../../fotastart";
import { routes } from "../../../backendRoutes";
import ProfileCompanyView from "./ProfileCompanyView";
import { ProfileProductView } from "../../Views/ProfileProductView";
import EditProductImageForm from "../../Forms/EditProductImageForm";
import Spinner from "../../Blocks/Spinner";
import { $e } from "../../../ojs.events";
import AlgoliaSearch from "../../../classes/AlgoliaSearch";

const h = app("h");
const broker = app("broker");

ojs(ProfileCompanyView, ProfileProductView, EditProductImageForm, Spinner);

export default class Profile extends Component {
    activeTab = "products";
    cropper = { obj: null };

    pageMap = {
        publicProducts: { next: 0, total: 0 },
        bookmarkedProducts: { next: 0, total: 0 },
        bookmarkedCompanies: { next: 0, total: 0 },
    };

    constructor() {
        super();
        dc.searchQuery.value = "";
        this.resetMap();
    }

    $$ojs = {
        routeChanged: () => this.resetMap(),
    };

    $$app = {
        has: {
            searchQuery: (ed, event) => {
                this.pageMap.publicProducts = { next: 0, total: 0 };
                this.getProducts("c-profile-my-products");

                this.pageMap.bookmarkedProducts = { next: 0, total: 0 };
                this.getBookmarkProducts("c-profile-saved-products");

                this.pageMap.bookmarkedCompanies = { next: 0, total: 0 };
                this.getBookmarkCompanies("c-profile-fav-companies");

                let navBar = dom.get("[hook='profile-nav-bar']");

                if (navBar) {
                    navBar.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                }
            },
            searchCharacter: async (ed, event) => {
                const { message } = eParse(ed);
                let query = message.get("value");

                if (empty(query)) {
                    dc.searchSuggestions.value = [];
                    return;
                }

                /**
                 * @type {AlgoliaSearch}
                 */
                let client = app("AlgoliaSearch");

                let result = await client.getSuggestions(query);
                dc.searchSuggestions.value = result;
            },
        },
    };

    render(userState, ...args) {
        let user = userState?.value;

        pageInfo(PAGES.PROFILE);
        pc.pageTitle.value = user?.display_name || user?.username;

        if (empty(user?.id)) {
            return h.Spinner();
        }

        this.resetMap();
        searchPlaceholder("Find any Item...");

        return h.div(
            {
                class: "mx-auto w-100 pb-3 py-5 mb-5 py-md-5",
                style: "max-width: 550px; margin-bottom: 25vh;",
            },

            h.div(
                {
                    class: "d-flex flex-column align-items-center pt-4 pb-3 px-3",
                },

                // Avatar
                h.div(
                    { class: "position-relative mb-3" },
                    h.img(
                        either(
                            user?.profile_photo_path,
                            [{ src: user?.profile_photo_path }],
                            { src: "/assets/images/user-avatar.png" },
                        ),
                        {
                            class: "rounded-circle border border-3 border-white shadow",
                            style: "width: 90px; height: 90px; object-fit: cover;",
                            id: "user-profile-avatar",
                            onclick: this.method("changeAvatar"),
                            style: "width: 90px; height: 90px; object-fit: cover; cursor: pointer;",
                        },
                    ),

                    h.div(
                        {
                            class: "position-absolute bottom-0 end-0 d-flex align-items-center justify-content-center rounded-circle border border-2 border-white",
                            style: "width: 26px; height: 26px; background: rgba(0,0,0,0.6); cursor: pointer;",
                            onclick: this.method("changeAvatar"),
                        },
                        h.i({
                            class: "fas fa-camera text-white",
                            style: "font-size: 0.65rem;",
                        }),
                    ),
                ),

                // Handle & Display Name
                h.div(
                    { class: "text-center mb-2" },
                    h.div(
                        {
                            class: "text-secondary small",
                            style: "opacity: 0.75;",
                        },
                        h.span({ style: "opacity: 0.6;" }, "@"),
                        h.span({ class: "fw-semibold" }, user?.username),
                    ),
                    either(user?.bio, () =>
                        h.div(
                            {
                                class: "text-secondary small mt-1 px-4",
                                style: "line-height: 1.45; max-width: 320px;",
                            },
                            user?.bio,
                        ),
                    ),
                ),

                // ─── Stats Pills ──────────────────────────────────────
                h.div(
                    {
                        class: "d-flex gap-2 justify-content-center flex-wrap mt-3 mb-3 w-100",
                    },

                    // Orders
                    h.div(
                        {
                            class: "profile-stat-pill d-flex flex-column align-items-center px-3 py-2 rounded-4 bg-white border shadow-sm",
                            style: "min-width: 78px;",
                            onclick: h.func("app('router').to", "orders.index"),
                        },
                        h.div(
                            { class: "mb-1" },
                            h.i({
                                class: "bi bi-box-seam text-primary",
                                style: "font-size: 0.9rem;",
                            }),
                        ),
                        h.span(
                            {
                                class: "fw-bold text-dark",
                                style: "font-size: 1.05rem; line-height: 1;",
                            },
                            formatThousand(user?.order_count ?? 0),
                        ),
                        h.span(
                            {
                                class: "text-secondary mt-1",
                                style: "font-size: 0.65rem; letter-spacing: 0.5px; text-transform: uppercase;",
                            },
                            "Orders",
                        ),
                    ),

                    // Kappa Balance
                    v(uc.capa, (capa) => {
                        return h.div(
                            {
                                class: "profile-stat-pill d-flex flex-column align-items-center px-3 py-2 rounded-4 bg-white border shadow-sm",
                                style: "min-width: 78px; cursor: pointer;",
                                onclick: h.func(
                                    `app("router").to`,
                                    "user.view-wallet",
                                ),
                                title: "Capa Balance",
                            },
                            h.div(
                                { class: "mb-1" },
                                h.i({
                                    class: "bi bi-coin text-warning",
                                    style: "font-size: 0.9rem;",
                                }),
                            ),
                            h.span(
                                {
                                    class: "fw-bold text-dark",
                                    style: "font-size: 1.05rem; line-height: 1;",
                                },
                                dc.capaSymbol,
                                formatThousand(capa.value?.balance ?? 0),
                            ),
                            h.span(
                                {
                                    class: "text-secondary mt-1",
                                    style: "font-size: 0.65rem; letter-spacing: 0.5px; text-transform: uppercase;",
                                },
                                "Wallet",
                            ),
                        );
                    }),

                    // AI Credits
                    v(uc.aiCredit, (credit) => {
                        return h.div(
                            {
                                class: "profile-stat-pill d-flex flex-column align-items-center px-3 py-2 rounded-4 bg-white border shadow-sm",
                                style: "min-width: 78px; cursor: pointer;",
                                onclick: h.func(
                                    `app("router").to`,
                                    "user.ai-credits",
                                ),
                                title: "AI Credits",
                            },
                            h.div(
                                { class: "mb-1" },
                                h.i({
                                    class: "bi bi-stars text-warning",
                                    style: "font-size: 0.9rem;",
                                }),
                            ),
                            h.span(
                                {
                                    class: "fw-bold text-dark",
                                    style: "font-size: 1.05rem; line-height: 1;",
                                },
                                formatThousand(credit.value?.balance ?? 0),
                            ),
                            h.span(
                                {
                                    class: "text-secondary mt-1",
                                    style: "font-size: 0.65rem; letter-spacing: 0.5px; text-transform: uppercase;",
                                },
                                "AI Credits",
                            ),
                        );
                    }),
                ),

                h.div(
                    { class: "d-flex gap-2 justify-content-center mb-1" },
                    h.button(
                        {
                            class: "profile-edit-btn btn d-flex align-items-center gap-2 px-4 py-2 rounded-pill fw-semibold",
                            style: `
									background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
									border: 1.5px solid #dee2e6;
									color: #212529;
									font-size: 0.9rem;
									box-shadow: 0 2px 8px rgba(0,0,0,0.07);
								`,
                            onclick: h.func(
                                `app("router").to`,
                                "user.edit-profile",
                            ),
                        },
                        h.i({
                            class: "bi bi-pencil-square text-secondary",
                            style: "font-size: 0.85rem;",
                        }),
                        "Edit Profile",
                    ),
                ),
            ),

            h.Tabs(
                {
                    holders: {
                        nav: h.div({
                            class: "nav nav-underline nav-fill px-2",
                            style: "border-bottom: 1px solid #dee2e6; position: sticky; top: 56px; z-index: 10; background: #fff;",
                            hook: "profile-nav-bar",
                        }),
                        body: h.div({ class: "tab-content" }),
                    },
                    tabs: [
                        // ── Tab 1: Products ──
                        tab(
                            h.button(
                                {
                                    class: `nav-link d-flex align-items-center justify-content-center gap-2 py-3 ${this.activeTab === "products" ? "active fw-semibold text-dark" : "text-secondary"}`,
                                    listeners: {
                                        click: () => {
                                            this.activeTab = "products";
                                            searchPlaceholder(
                                                "Find any Item...",
                                            );
                                        },
                                    },
                                },
                                h.i({ class: "bi bi-box" }),
                                h.span(
                                    { class: "d-none d-sm-inline small" },
                                    "Products",
                                ),
                            ),
                            h.div(
                                {
                                    class: `tab-pane fade pt-3 ${this.activeTab === "products" ? "show active" : ""}`,
                                },
                                h.InfiniteScroll({
                                    child: h.div({
                                        id: "c-profile-my-products",
                                        class: "d-flex gap-3 gap-md-4 flex-wrap justify-content-around justify-content-md-start",
                                    }),
                                    callback: (entries, observer, marker) => {
                                        entries.forEach((entry) => {
                                            if (!entry.isIntersecting) return;
                                            this.populateProducts(
                                                "c-profile-my-products",
                                                marker,
                                            );
                                        });
                                    },
                                }),
                            ),
                        ),

                        // ── Tab 2: Saved (Bookmarks) ──
                        tab(
                            h.button(
                                {
                                    class: `nav-link d-flex align-items-center justify-content-center gap-2 py-3 ${this.activeTab === "bookmarks" ? "active fw-semibold text-dark" : "text-secondary"}`,
                                    listeners: {
                                        click: () => {
                                            this.activeTab = "bookmarks";
                                            searchPlaceholder(
                                                "Find a favorite...",
                                            );
                                        },
                                    },
                                },
                                h.i({ class: "bi bi-bookmark" }),
                                h.span(
                                    { class: "d-none d-sm-inline small" },
                                    "Saved",
                                ),
                            ),
                            h.div(
                                {
                                    class: `tab-pane fade pt-3 ${this.activeTab === "bookmarks" ? "show active" : ""}`,
                                },
                                h.InfiniteScroll({
                                    child: h.div({
                                        id: "c-profile-saved-products",
                                        class: "d-flex gap-3 gap-md-4 flex-wrap justify-content-around justify-content-md-start",
                                    }),
                                    callback: (entries, observer, marker) => {
                                        entries.forEach((entry) => {
                                            if (!entry.isIntersecting) return;
                                            this.populateBookmarkedProducts(
                                                "c-profile-saved-products",
                                                marker,
                                            );
                                        });
                                    },
                                }),
                            ),
                        ),

                        // ── Tab 3: Favorite Companies ──
                        tab(
                            h.button(
                                {
                                    class: `nav-link d-flex align-items-center justify-content-center gap-2 py-3 ${this.activeTab === "companies" ? "active fw-semibold text-dark" : "text-secondary"}`,
                                    listeners: {
                                        click: () => {
                                            this.activeTab = "companies";
                                            searchPlaceholder(
                                                "Find favorite business...",
                                            );
                                        },
                                    },
                                },
                                h.i({ class: "bi bi-shop" }),
                                h.span(
                                    { class: "d-none d-sm-inline small" },
                                    "Favorites",
                                ),
                            ),
                            h.div(
                                {
                                    class: `tab-pane fade pt-3 ${this.activeTab === "companies" ? "show active" : ""}`,
                                },
                                h.InfiniteScroll({
                                    child: h.div({
                                        id: "c-profile-fav-companies",
                                        class: "row g-3 pt-2",
                                    }),
                                    callback: (entries, observer, marker) => {
                                        entries.forEach((entry) => {
                                            if (!entry.isIntersecting) return;
                                            this.populateBookmarkedCompanies(
                                                "c-profile-fav-companies",
                                                marker,
                                            );
                                        });
                                    },
                                }),
                            ),
                        ),
                    ],
                },
                { $class: "mb-3" },
            ),

            h.div({ style: "margin-bottom: 8rem;" }),

            h.Fab([
                h.button(
                    {
                        class: "btn text-white",
                        style: "background: linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%);",
                        onclick: this.method("addProduct"),
                    },
                    h.i({ class: "bi bi-stars" }),
                ),
            ]),

            h.SuggestedUsersCanvas({
                c_profile_su_canvas: "profile-su-canvas",
            }),

            // Hidden image upload input
            h.input({
                type: "file",
                id: "profile-image-upload",
                class: "d-none",
                accept: "image/*",
                listeners: {
                    change: (e) => this.handleImageUpload(e),
                },
            }),

            ...args,
        );
    }

    // ─── Product Population ───────────────────────────────────────────

    async getProducts(holderId, spinnerHolder = null) {
        if (this.pageMap.publicProducts.total > 0) {
            this.pageMap.publicProducts.next++;
        }

        let page = this.pageMap.publicProducts.next;
        let query = dc.searchQuery.value ?? "";

        let userId = gc.user?.value?.id;
        let spinner = null;

        if (spinnerHolder) {
            spinner = h.Spinner({ parent: spinnerHolder, resetParent: true });
        }

        let qs = {
            page,
            interval: 10,
        };

        if (!empty(query)) {
            qs.query = query;
        }

        let res = await api.get(
            `${routes.users}/${userId}/products/public`,
            qs,
        );

        if (res) {
            let products = res.data.products.data;
            let currentPage = res.data.products.current_page;
            this.pageMap.publicProducts.total = res.data.products.total ?? 0;

            const holder = dom.id(holderId);

            if (currentPage == 1) {
                dom.empty(holder);
            }

            for (let product of products) {
                if (!dom.get(`[feed-product-id="p-${product.id}"]`, holder)) {
                    h.ProfileProductView(product, {
                        $class: "flex-fill",
                        $style: "max-width: 160px;",
                        parent: holder,
                        $feed_product_id: `p-${product.id}`,
                        listeners: {
                            click: () =>
                                broker.send(
                                    $e.product.needs.display,
                                    payload({ product }),
                                ),
                        },
                    });
                }
            }

            if (empty(products) && currentPage == 1) {
                this._showEmpty(holderId, "No products added yet.");
            }

            if (empty(products))
                this.pageMap.publicProducts.next = Math.min(currentPage - 1, 0);
        }

        spinner?.remove();

        if (this.activeTab == "products") {
            clearSearchSuggestion();
        }

        if (!empty(query)) {
            let navBar = dom.get("[hook='profile-nav-bar']");

            if (navBar) {
                navBar.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }
    }

    async populateProducts(holderId, marker) {
        this.getProducts(holderId, marker);
    }

    async getBookmarkProducts(holderId, spinnerHolder = null) {
        if (this.pageMap.bookmarkedCompanies.total > 0) {
            this.pageMap.bookmarkedProducts.next++;
        }
        let page = this.pageMap.bookmarkedProducts.next;
        let query = dc.searchQuery.value ?? "";
        let spinner = null;

        if (spinnerHolder) {
            spinner = h.Spinner({ parent: spinnerHolder, resetParent: true });
        }

        let qs = {
            page,
            interval: 10,
        };

        if (!empty(query)) {
            qs.query = query;
        }

        let res = await api.get(`${routes.users}/products/bookmarked`, qs);

        if (res) {
            let products = res.data.products.data;
            let currentPage = res.data.products.current_page;
            this.pageMap.bookmarkedCompanies.total =
                res.data.products.total ?? 0;

            const holder = dom.id(holderId);

            if (currentPage == 1) {
                dom.empty(holder);
            }

            for (let product of products) {
                if (!dom.get(`[feed-product-id="p-${product.id}"]`, holder)) {
                    h.ProfileProductView(product, {
                        class: "flex-fill",
                        style: "max-width: 160px;",
                        parent: holder,
                        $feed_product_id: `p-${product.id}`,
                        listeners: {
                            click: () =>
                                broker.send(
                                    $e.product.needs.display,
                                    payload({ product }),
                                ),
                        },
                    });
                }
            }

            if (empty(products) && currentPage == 1) {
                this._showEmpty(holderId, "No bookmarked products yet.");
            }

            if (empty(products))
                this.pageMap.bookmarkedProducts.next = Math.min(
                    currentPage - 1,
                    0,
                );
        }

        spinner?.remove();

        if (this.activeTab == "bookmarks") {
            clearSearchSuggestion();
        }

        if (!empty(query)) {
            let navBar = dom.get("[hook='profile-nav-bar']");

            if (navBar) {
                navBar.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }
    }

    async populateBookmarkedProducts(holderId, marker) {
        this.getBookmarkProducts(holderId, marker);
    }

    async getBookmarkCompanies(holderId, spinnerHolder = null) {
        if (this.pageMap.bookmarkedCompanies.total > 0) {
            this.pageMap.bookmarkedCompanies.next++;
        }

        let page = this.pageMap.bookmarkedCompanies.next;
        let query = dc.searchQuery.value ?? "";
        let spinner = null;

        if (spinnerHolder) {
            spinner = h.Spinner({ parent: spinnerHolder, resetParent: true });
        }

        let qs = {
            page,
            interval: 10,
        };

        if (!empty(query)) {
            qs.query = query;
        }

        let res = await api.get(`${routes.users}/companies/bookmarked`, qs);

        if (res) {
            let companies = res.data.companies.data;
            let currentPage = res.data.companies.current_page;
            this.pageMap.bookmarkedCompanies.total =
                res.data.companies.total ?? 0;

            const holder = dom.id(holderId);

            if (currentPage == 1) {
                dom.empty(holder);
            }

            for (let company of companies) {
                if (!dom.get(`[data-company-id="${company.id}"]`, holder)) {
                    h.ProfileCompanyView(company, { parent: holder });
                }
            }

            if (empty(companies) && currentPage == 1) {
                h.div(
                    {
                        parent: holder,
                        resetParent: true,
                        class: "text-center py-5",
                        id: "vp-companies-empty",
                    },
                    h.div(
                        {
                            class: "rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3",
                            style: "width: 64px; height: 64px; background: rgba(99,102,241,0.08);",
                        },
                        h.i({
                            class: "bi bi-shop text-primary",
                            style: "font-size: 1.5rem;",
                        }),
                    ),
                    h.p(
                        { class: "text-secondary mb-0 fst-italic small" },
                        "No favorite companies yet.",
                    ),
                    h.p(
                        { class: "text-secondary small" },
                        "Browse businesses and mark them as favorites!",
                    ),
                );
            }

            if (empty(companies))
                this.pageMap.bookmarkedCompanies.next = Math.min(
                    currentPage - 1,
                    0,
                );
        }

        spinner?.remove();

        if (this.activeTab == "companies") {
            clearSearchSuggestion();
        }

        if (!empty(query)) {
            let navBar = dom.get("[hook='profile-nav-bar']");

            if (navBar) {
                navBar.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }
    }

    async populateBookmarkedCompanies(holderId, marker) {
        this.getBookmarkCompanies(holderId, marker);
    }

    _showEmpty(holderId, message) {
        const holder = dom.id(holderId);
        if (!holder) return;

        h.div(
            {
                parent: holder,
                resetParent: true,
                class: "text-center py-5",
                id: "vp-no-item-found",
            },
            h.div(
                {
                    class: "rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3",
                    style: "width: 56px; height: 56px; background: rgba(0,0,0,0.04);",
                },
                h.i({
                    class: "bi bi-box",
                    style: "font-size: 1.3rem; opacity: 0.4;",
                }),
            ),
            h.p({ class: "text-secondary fst-italic small mb-0" }, message),
        );
    }

    changeAvatar() {
        document.getElementById("profile-image-upload").click();
    }

    handleImageUpload(e) {
        const files = e.target.files;
        if (!files.length) return;

        const file = files[0];
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.addEventListener("load", () => {
            const src = fileReader.result;
            const options = new tool.ModalOptions();
            options.buttons.right.text = "Crop & Confirm";
            options.buttons.left.text = "Cancel";
            options.classes.buttons.right = "btn btn-primary rounded-pill px-4";
            options.classes.dialog = "modal-lg modal-fullscreen-md-down";
            options.staticBackdrop();

            const { buttons, modal } = tool.modal(
                "Crop Profile Image",
                h.EditProductImageForm(src),
                options,
            );

            modal.element.addEventListener("shown.bs.modal", () => {
                const preview = dom.id("epif-image-view");
                preview.classList.remove("d-none");

                this.cropper.obj = new Cropper(preview, {
                    aspectRatio: 1 / 1,
                    viewMode: 2,
                    minContainerHeight: 350,
                });
            });

            buttons.left.button.addEventListener("click", () => modal.close());

            buttons.right.button.addEventListener("click", async () => {
                if (!this.cropper.obj) return;
                const cropData = this.cropper.obj.getData();
                modal.close();
                await this.uploadProfilePic(file, cropData);
            });
        });
    }

    async uploadProfilePic(file, cropBox) {
        try {
            broker.broadcast($e.app.indicator.process.start);

            const arrayBuffer = await file.arrayBuffer();
            const robustBlob = new Blob([arrayBuffer], { type: file.type });

            const formData = new FormData();
            formData.append("image", robustBlob);
            formData.append("crop_using", JSON.stringify(cropBox));

            const res = await api.post("users/profile-picture", formData, {
                fetch_using: "browser",
                "remove-content-type": true,
            });
            if (res) {
                inform(
                    res.message || "Profile picture updated successfully",
                    STRINGS.SUCCESS,
                );
                gc.user.value = res.data.user;
            }
        } catch (error) {
            inform(
                error.response?.data?.message || "Failed to upload image",
                STRINGS.ERROR,
            );
        } finally {
            broker.broadcast($e.app.indicator.process.end);
        }
    }

    resetMap() {
        this.pageMap.publicProducts = { next: 0, total: 0 };
        this.pageMap.bookmarkedProducts = { next: 0, total: 0 };
        this.pageMap.bookmarkedCompanies = { next: 0, total: 0 };
    }

    async showProduct(product) {
        broker.send($e.product.needs.display, payload({ product }));
    }

    async addProduct() {
        fireEvent($e.product.needs.creation);
    }
}

ojs(Profile);
